const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.86344 8.9615C7.86344 9.26879 7.76709 9.50381 7.57438 9.66657C7.38298 9.82934 7.11019 9.91072 6.75602 9.91072H6.49626V10.9263H5.89079V8.07087H6.8029C7.14925 8.07087 7.41227 8.14574 7.59196 8.29548C7.77295 8.44392 7.86344 8.66592 7.86344 8.9615ZM6.49626 9.41462H6.69548C6.88167 9.41462 7.021 9.37816 7.11344 9.30525C7.20589 9.23103 7.25212 9.12361 7.25212 8.98298C7.25212 8.84105 7.21305 8.73624 7.13493 8.66853C7.0581 8.60082 6.93701 8.56697 6.77165 8.56697H6.49626V9.41462Z",
  fill: "#1E3F6B"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.7716 9.47126C10.7716 9.94131 10.6375 10.3013 10.3693 10.5513C10.1024 10.8013 9.71631 10.9263 9.2111 10.9263H8.40251V8.07087H9.29899C9.76514 8.07087 10.1271 8.19392 10.3849 8.44001C10.6427 8.68611 10.7716 9.02986 10.7716 9.47126ZM10.1427 9.48689C10.1427 8.87361 9.87191 8.56697 9.33024 8.56697H9.00797V10.4263H9.26774C9.85107 10.4263 10.1427 10.1132 10.1427 9.48689Z",
  fill: "#1E3F6B"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.3634 10.9263H11.9591V9.79743H12.9279V9.30329H11.9591V8.56697H13.0002V8.07087H11.3634V10.9263Z",
  fill: "#1E3F6B"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2633 1.55981L12.8635 4.30947C12.9512 4.40231 13.0002 4.52523 13.0002 4.65301V6.16634H14.1668C14.443 6.16634 14.6668 6.3902 14.6668 6.66634V12.333C14.6668 12.6091 14.443 12.833 14.1668 12.833H13.0002V13.4997C13.0002 13.8091 12.8772 14.1058 12.6585 14.3246C12.4397 14.5434 12.1429 14.6663 11.8335 14.6663H2.50016C2.19074 14.6663 1.894 14.5434 1.6752 14.3246C1.45641 14.1058 1.3335 13.8091 1.3335 13.4997V2.49967C1.3335 2.19026 1.45641 1.89351 1.6752 1.67472C1.894 1.45592 2.19074 1.33301 2.50016 1.33301H9.8335C9.93666 1.33301 10.0364 1.36489 10.1197 1.42302C10.1762 1.45862 10.2251 1.50522 10.2633 1.55981ZM2.38231 2.38182C2.41357 2.35057 2.45596 2.33301 2.50016 2.33301H9.3535V4.65301C9.3535 4.92915 9.57735 5.15301 9.8535 5.15301H12.0002V6.16634H4.66683C4.39069 6.16634 4.16683 6.3902 4.16683 6.66634V12.333C4.16683 12.6091 4.39069 12.833 4.66683 12.833H12.0002V13.4997C12.0002 13.5439 11.9826 13.5863 11.9513 13.6175C11.9201 13.6488 11.8777 13.6663 11.8335 13.6663H2.50016C2.45596 13.6663 2.41357 13.6488 2.38231 13.6175C2.35106 13.5863 2.3335 13.5439 2.3335 13.4997V2.49967C2.3335 2.45547 2.35106 2.41308 2.38231 2.38182ZM11.3392 4.15301L10.3535 3.11063V4.15301H11.3392ZM5.16683 7.16634V11.833H13.6668V7.16634H5.16683Z",
  fill: "#1E3F6B"
});

const SvgPdf = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPdf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pdf.b2bf929f.svg";
export { ForwardRef as ReactComponent };